import globals from "@homer.core/globals";
import StorageSession from "@homer.core/storage.session";
import application from "@homer.core/application";
import { name } from "../package.json";

const storageSession = new StorageSession(name, { version: application.version });

// Reuse the stateless encoder across identity updates.
const textEncoder = new TextEncoder();

const sha256 = async (value) => {
    const msgBuffer = textEncoder.encode(value);
    const hashBuffer = await crypto.subtle.digest("SHA-256", msgBuffer);

    return Array.from(new Uint8Array(hashBuffer))
        .map((b) => b.toString(16).padStart(2, "0"))
        .join("");
};

class Email {
    #method;
    #plain;
    #hash;

    constructor({ email, hash, method }) {
        this.#method = method || undefined;
        this.#plain = email;
        this.#hash = hash;
    }

    async set(email, method = undefined, enforce = false) {
        if (email) {
            if (enforce || method !== this.#method || email !== this.#plain) {
                const hash = email !== this.#plain ? await sha256(email) : this.#hash;

                storageSession.set(JSON.stringify({ email, hash, method: method || undefined }));

                this.#method = method || undefined;
                this.#plain = email;
                this.#hash = hash;

                void globals.demand.request("@unifold/event.user.identify").then(([UserIdentifyEvent]) => {
                    new UserIdentifyEvent({ method: method || "unknown", email: hash }).dispatch();
                });
            }
        } else {
            storageSession.remove();

            this.#method = undefined;
            this.#plain = undefined;
            this.#hash = undefined;
        }
    }

    get method() {
        return this.#method;
    }

    get plain() {
        return this.#plain;
    }

    get hash() {
        return this.#hash;
    }
}

export default new Email(JSON.parse(storageSession.get() || "{}"));
